export default __webpack_public_path__ + "static/media/teams-card-img-1.e274c82a.png";